export * from './chart.component';
